<div>
  <app-header style="position: absolute; top: 15px"></app-header>
  <div class="z-contenedor d-flex align-items-center justify-content-center page-error">
    <div class="row align-items-center page-error__container">
      <div class="col-md-6 d-flex justify-content-center flex-column align-items-center page-error__http-error">
        <figure class="z-iconos img-error" style="width: 80% !important; height: 100% !important">
          <img src="assets/img/svg/icon-ilus-ko.svg" draggable="false" alt="Icono ilustracion KO" />
        </figure>
        <h1 class="z-titulo z-negro">{{ this.statusCode }}</h1>
        <h2 class="z-titulo">
          {{ this.descripcionError }}
        </h2>
      </div>
      <div class="col-md-6">
        <h1 class="z-titulo">Oops!</h1>
        <h2 class="z-titulo mt-3 page-error__page-not-found">
          {{ this.titulo }}
        </h2>
        <p class="mt-4">{{ this.mensaje }}</p>
        <button (click)="redireccionar()" type="button" class="z-btn z-btn-primary mt-5">
          Ir a inicio
        </button>
      </div>
    </div>
  </div>
</div>